<template>
    <header
        class="header"
        :class="{
            [`theme-${theme}`]: true,
        }"
    >
        <div class="topbar">
            <div v-if="$slots.left && $bp.bps.isDesktop" class="left">
                <slot name="left" />
            </div>
            <div v-if="$slots.logo" class="center">
                <slot name="logo" />
            </div>
            <div v-if="$slots.right && $bp.bps.isDesktop" class="right">
                <slot name="right" />
            </div>
            <div v-if="$slots.mobile && !$bp.bps.isDesktop" class="mobile">
                <slot name="mobile" />
            </div>
        </div>
        <LayoutNavigation
            class="main-nav"
            :content="navigation"
        />
    </header>
</template>
<script setup>
import { provide, useNuxtApp } from '#imports';
const { $bp } = useNuxtApp();

const props = defineProps({
    navigation: {
        type: Array,
        required: false,
        default: () => [],
    },
    theme: {
        type: String,
        required: false,
        default: 'black',
    },
    logo: {
        type: [Array, Object],
        required: false,
        default: () => ({
            src: '',
            alt: '',
        }),
    },
});
provide('theme', props.theme);
</script>
<style scoped>
.header {
  width: 100%;
  align-items: center;
  padding-top: 3rem;
  grid-gap: 1.5rem 0;
  align-self: start;
  position: fixed;
  top: 0;
  margin: 0 auto;
  max-width: 100%;
}
.header.theme-black {
  background: #000;
}
.header.theme-black a {
  color: var(--color-base-white);
}
.header.theme-white {
  background: var(--color-base-white);
}
.header .topbar {
  display: grid;
  margin: 0 auto;
  width: 100%;
  margin-bottom: 1.5rem;
  max-width: calc(var(--desktop-max-width) + 3rem);
  padding-inline: 1.5rem;
  grid-template-columns: repeat(3, minmax(0, 480px));
  align-items: center;
}
.header .left {
  display: inline-flex;
  align-items: center;
}
.header .center {
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
@media (min-width: 1200px) {
  .header .center {
    grid-column-start: 2;
  }
}
.header .right {
  display: inline-flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: flex-end;
}
.header .right > *:not(:last-child) {
  margin-right: 1rem;
}
.header .mobile {
  display: inline-flex;
  flex-flow: row wrap;
  align-items: center;
  justify-self: right;
}
.header .mobile > *:not(:last-child) {
  margin-right: 1rem;
}
@media (min-width: 1200px) {
  .header .mobile {
    display: none;
  }
}
@media (max-width: 1199px) {
  .header {
    display: grid;
    position: fixed;
    padding: 0 1.5rem;
    grid-template-columns: auto 1fr;
    grid-template-rows: 1fr;
    height: 4rem;
    align-items: center;
    top: 0;
  }
  .header .main-nav {
    grid-row-start: 1;
    grid-column-start: 1;
    grid-column-end: 3;
  }
  .header .topbar {
    grid-template-columns: auto 1fr;
    grid-row-start: 1;
    grid-column-start: 2;
    margin-bottom: 0;
    padding-right: 0;
    padding-left: 3rem;
  }
}
</style>
